import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import useHomeDashboardData from "hooks/dashboard/useHomeDashboardData";

const DashboardContext = createContext(null);

const DashboardProvider = ({ children, scope = "full" }) => {
  const dashboard = useHomeDashboardData({ scope });

  return (
    <DashboardContext.Provider value={dashboard}>
      {children}
    </DashboardContext.Provider>
  );
};

DashboardProvider.propTypes = {
  children: PropTypes.node,
  scope: PropTypes.oneOf(["full", "analytics"]),
};

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error("useDashboard must be used within a DashboardProvider");
  }
  return context;
};

export default DashboardProvider;
